import React from 'react';
import axios from 'axios';

class CustomFileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.fileRef = React.createRef();
  }

  uploadFile() {
    var file = this.fileRef.current.files[0];
    var data = new FormData();
    data.append('file', file);
    axios
      .post(this.props.action, data)
      .then(() => location.reload());
  }

  render() {
    const name = this.props.name
    return (
      <div className="field custom-file-upload" style={ { display: 'inline-block' } }>
        <label htmlFor="file-upload" className="button is-primary">
          { name } &nbsp;<i className="fa fa-cloud-upload"></i>
        </label>
        <input id="file-upload" type="file" ref={this.fileRef} onChange={this.uploadFile.bind(this)} />
      </div>
    )
  }
}

export default CustomFileUpload
